import { facilityQuery } from "@common/api/facilities"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { FacilityDetailsForm } from "@/routes/_layout/settings/_panel/workspace/facilities/-components/form/facility-details-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId",
)({
  loader: ({ context: { queryClient }, params: { facilityId } }) =>
    queryClient.ensureQueryData(facilityQuery(facilityId)),
  staticData: { detailSidebar: true },
  component: FacilityPanel,
})

function FacilityPanel(): React.ReactElement {
  const { facilityId } = Route.useParams()
  const { data: facility } = useSuspenseQuery(facilityQuery(facilityId))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({ to: "/settings/workspace/facilities", search: true })

  return (
    <FacilityDetailsForm
      key={`${facility.id}-${facility.deleted_at}`}
      facility={facility}
      onClose={close}
      onRestore={() => {
        showToast("Restored", "Facility and its locations restored.", "success")
        navigate({
          to: "/settings/workspace/facilities/$facilityId",
          params: { facilityId },
          search: (previous) => ({ ...previous, archived_locations: true }),
          replace: true,
        })
      }}
      onSave={(saved) =>
        showToast("Saved", `${saved.name} updated.`, "success")
      }
    >
      <Outlet />
    </FacilityDetailsForm>
  )
}
